import { Head, Link } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import SettingsLayout from "@/layouts/settings_layout";
export default function LocationHistories({
  locations,
}: {
  locations: { id: string; name: string; active: boolean }[];
}) {
  const { t } = useTranslation();
  return (
    <SettingsLayout>
      <Head title={t("resources.retained_history")} />
      <div className="space-y-4">
        <h1 className="text-page font-display">
          {t("resources.retained_history")}
        </h1>
        <p className="text-muted-foreground text-sm">
          {t("resources.history_help")}
        </p>
        <div className="flex flex-wrap gap-3">
          {locations.map((location) => (
            <Button
              key={location.id}
              variant="outline"
              nativeButton={false}
              render={<Link href={`/user/location_histories/${location.id}`} />}
            >
              {location.name}
              {!location.active && ` · ${t("resources.inactive")}`}
            </Button>
          ))}
        </div>
      </div>
    </SettingsLayout>
  );
}
